import { render, staticRenderFns } from "./GroupOptionsView.vue?vue&type=template&id=1724bfde&scoped=true&"
import script from "./GroupOptionsView.vue?vue&type=script&lang=js&"
export * from "./GroupOptionsView.vue?vue&type=script&lang=js&"
import style0 from "./GroupOptionsView.vue?vue&type=style&index=0&id=1724bfde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1724bfde",
  null
  
)

export default component.exports